'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

const GTM_ID = 'GTM-PSCZZCX';

const DeferredTagManager = () => {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const enable = () => setShouldLoad(true);

    const onInteraction = () => {
      enable();
      cleanup();
    };

    const cleanup = () => {
      window.removeEventListener('pointerdown', onInteraction);
      window.removeEventListener('keydown', onInteraction);
      window.removeEventListener('scroll', onInteraction);
    };

    window.addEventListener('pointerdown', onInteraction, { once: true, passive: true });
    window.addEventListener('keydown', onInteraction, { once: true });
    window.addEventListener('scroll', onInteraction, { once: true, passive: true });

    return cleanup;
  }, []);

  if (!shouldLoad) return null;

  return (
    <>
      <Script id="gtm-bootstrap" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || [];window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});`}
      </Script>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`}
      />
    </>
  );
};

export default DeferredTagManager;
